import ThibodauxHeroSection from "./components/HeroSection";
import ThibodauxStickyNav from "./components/StickyNav";
import ThibodauxProcessingTimeSection from "./components/ProcessingTimeSection";
import ThibodauxServicesSection from "./components/ServicesSection";
import ThibodauxLocalAreaSection from "./components/LocalAreaSection";
import ThibodauxTestimonialsSection from "./components/TestimonialsSection";
import ThibodauxAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ThibodauxComparisonSection from "./components/ComparisonSection";
import ThibodauxMistakesSection from "./components/MistakesSection";
import ThibodauxHowItWorksSection from "./components/HowItWorksSection";
import ThibodauxFAQSection, { faqs } from "./components/FAQSection";
import ThibodauxHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import ThibodauxFinalCTA from "./components/FinalCTA";
import ThibodauxTravelTimingSection from "./components/TravelTimingSection";
import ThibodauxDestinationsSection from "./components/DestinationsSection";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function ThibodauxPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Thibodaux"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/thibodaux"
        title="Emergency Passport Thibodaux, LA — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Thibodaux, LA — as fast as 24 hours. Serving offshore workers, Nicholls State travelers, and Lafourche Parish families. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Thibodaux, Louisiana"
        geoPosition="29.7958;-90.8229"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <ThibodauxHeroSection />
      <ThibodauxStickyNav />
      <ThibodauxProcessingTimeSection />
      <ThibodauxServicesSection />
      <ThibodauxLocalAreaSection />
      <ThibodauxTravelTimingSection />
      <ThibodauxDestinationsSection />
      <ThibodauxTestimonialsSection />
      <ThibodauxAcceptanceFacilitiesSection />
      <ThibodauxComparisonSection />
      <ThibodauxMistakesSection />
      <ThibodauxHowItWorksSection />
      <ThibodauxFAQSection />
      <ThibodauxHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/thibodaux" state="LA" />
      <ThibodauxFinalCTA />
    </div>
  );
}